import { Context } from '@/pipeline/stateMachine';
import { AnyEventObject, StateConfig } from 'xstate';

export interface PipelineState {
  id?: number;
  currentState?: StateConfig<Context, AnyEventObject>;
}

const state: PipelineState = {
  id: undefined,
  currentState: undefined,
};

export default state;
